import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';

import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import { SortDirection } from '@mui/material';
import { useSearch } from '../../components/searchContext';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import CustomPaginationActionsTable from '../../components/TablePagination';
import { formatPrice } from '../../utils/storageUtil';

const InventoryHistory: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { inventoryId } = useParams<{ inventoryId: any }>();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const { searchQuery } = useSearch();
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [rows, setRows] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const [paginate, setPaginate] = useState({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('asc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  const handlePagination = (paginationData: any) => setPaginate(paginationData);
  useEffect(() => {
    if (isInitialLoad.current) {
      if (inventoryId) {
        if (!currentRecord) fetchOrderDetails(inventoryId);
      } else {
        setCurrentRecord(null);
      }

      isInitialLoad.current = false;
    }
    if (inventoryId) {
      fetchInventoryTransaction(inventoryId);
    }
  }, [inventoryId, paginate]);
  const getReasonsTypeData = (strData: any) => {
    const AdjustmentType: any = {
      adjustment: 'Adjustment',
      purchase: 'Purchase',
      transferSent: 'Transfer Sent',
      transferReceived: 'Transfer Received',
      dispatchSent: 'Dispatch Sent',
      dispatchReceived: 'Dispatch Received',
      shiftUsage: 'Shift Usage',
    };
    return AdjustmentType[strData] ?? strData;
  };
  const columns: any[] = [
    {
      field: 'createdDate',
      headerName: 'Date',
    },
    {
      field: 'projectId',
      headerName: 'Project#',
    },
    {
      field: 'location',
      headerName: 'Location',
    },
    {
      field: 'purchaseOrderNumber',
      headerName: 'Purchase Order Number ',
    },
    {
      field: 'orderedQty',
      headerName: 'Quantity Ordered',
      valueGetter: (value: any) => formatPrice(value),
    },
    {
      field: 'recievedQty',
      headerName: 'Received Quantity',
      valueGetter: (value: any) => formatPrice(value),
    },
    {
      field: 'backorderedQty',
      headerName: 'Backordered Quantity',
      valueGetter: (value: any) => formatPrice(value),
    },

    {
      field: 'adjQuantity',
      headerName: 'Adjustment Quantity',
    },
    {
      field: 'reason',
      headerName: 'Adjustment Reason',
      renderCell: (value: any, row: any) => (
        <Box>{value ? value.name : getReasonsTypeData(row.adjustmentType)}</Box>
      ),
    },
  ];

  const fetchInventoryTransaction = async (currentId: any) => {
    try {
      const searchQueries: any = {
        search: searchQuery,
        limit: paginate.limit,
        offset: paginate.offset,
      };

      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.inventoryURL}/items/${currentId}/transactions`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        searchQueries
      );
      //console.log(response);
      if (response.data) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('id');
        return true;
      } else {
        setRows([]);
        setTotalRecords(0);
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };

  const fetchOrderDetails = async (currentId: any) => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.inventoryURL}/items/${currentId}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {}
      );
      //console.log(response);
      if (response.data) {
        setCurrentRecord(response.data);

        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                navigate('/inventory/warehouse-onsite-inventory');
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>

            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                  overflowX: 'scroll',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#F9F9F9',
                    border: '1px solid #EFEEED',
                    borderRadius: '6px',
                    padding: ' 16px',
                  }}
                >
                  {currentRecord && (
                    <Grid container spacing={2}>
                      <Grid size={4}>
                        <h3 className="ovreview-label">Resource Name</h3>
                        {currentRecord.name}
                      </Grid>

                      {/* <Grid size={4}>
                        <h3 className="ovreview-label">{'SKU'}</h3>
                        {currentRecord.skuCode}
                      </Grid> */}
                      {/* <Grid size={4}>
                        <h3 className="ovreview-label">{'Contractor'}</h3>
                        {currentRecord.contractor.contractorName}
                      </Grid> */}
                    </Grid>
                  )}
                </Box>
              </Box>
              <Typography variant="h6" sx={{ m: 3 }}>
                Transactions
              </Typography>
              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                totalRecords={totalRecords}
                handlePagination={handlePagination}
                handleRowClick={(row: any) => {}}
                handleStatus={() => {}}
                paginationModel={{
                  page: paginate.offset,
                  pageSize: paginate.limit,
                }}
                order={order}
                orderBy={orderBy}
                handleOrderBy={handleOrderBy}
              />
            </Paper>
          </div>
        </div>
      </section>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default InventoryHistory;
